<template>
	<div class="glossary-index">
		<button type="button" class="btn-unstyled text-primary text-sm" @click="collapseAll">
			{{ $t('MAIN_CONTENT.GlossaryIndex.collapseAllTitleCase') }}
		</button> | 
		<button type="button" class="btn-unstyled text-primary text-sm" @click="expandAll">
			{{ $t('MAIN_CONTENT.GlossaryIndex.expandAllTitleCase') }}
		</button>
		<template v-for="letter in letters">
			<div class="index-item"
					:class="{'disabled' : !terms[letter].length}"
					:key="letter"
					role="listitem"
					v-if="terms[letter].length > 0">
				<a :aria-expanded="expanded.indexOf(letter) !== -1"
						class="index-toggle"
						href="javascript:void(0)"
						role="button"
						v-if="terms[letter].length"
						@click="toggleItem(letter)">
					<strong class="letter">{{ letter }}</strong>
					<i class="icon-caret fas fa-caret-down" aria-hidden="true" v-if="expanded.indexOf(letter) !== -1"></i>
					<i class="icon-caret fas fa-caret-right" aria-hidden="true" v-else></i>
				</a>
				<a aria-disabled="true"
						class="disabled"
						href="javascript:void(0)"
						v-else>
					<strong class="letter">{{ letter }}</strong>
				</a>
				<div class="terms-menu" v-if="expanded.indexOf(letter) !== -1">
					<ul v-if="terms[letter]">
						<li v-for="(term, termIdx) in terms[letter]" :key="`${letter}-${termIdx}`">
							<a aria-controls="glossary-results"
									href="javascript:void(0)"
									@click="showDefinition(term)">
								{{ term.TERM }}
							</a>
						</li>
					</ul>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import ALPHABET from "./constants.js";

	/**
		* @vue-prop {String} [locale=en] - Albphabet's language ( currently en - English or es - Spanish ).
		* @vue-prop {Object} [terms={}] - Array of the glossary entries.
		* @vue-data {Array} expanded - Letters that are expanded.
		* @vue-computed {Array} letters - The index letters.
	*/
	export default {
		props: {
			locale: {
				type: String,
				default: "en"
			},
			terms: {
				type: Object,
				default: function() {
					return {};
				}
			}
		},
		data() {
			return {
				...ALPHABET,
				expanded: []
			};
		},
		computed: {
			letters() {
				let letters = [];

				for(let term in this.terms) {
					letters.push(term);
				}
				return letters;
			}
		},
		methods: {
			/**
				* Collapses all the letters
			*/
			collapseAll() {
				this.expanded = [];
			},
			/**
				* Expands all the letters
			*/
			expandAll() {
				for(let i in this.letters) {
					if(this.terms[ this.letters[i] ].length) {
						this.expanded.push(this.letters[i]);
					}
				}
			},
			/**
				* Shows definition of the selected term.
				* @param {String} term - The term
			*/
			showDefinition(term) {
				let termArray = [];

				termArray.push(term);
				this.$emit('setFilterByValues', termArray);
				window.scrollTo(0, 0);
			},
			/**
				* Toggles the letter between expanded and collapsed
				* If expanded, filters terms by letter
				* @param {String} letter - The letter to toggle
			*/
			toggleItem(letter) {
				let index = this.expanded.indexOf(letter);

				if(index >= 0) {
					this.expanded.splice(index, 1);
				} else {
					this.expanded.push(letter);
				}
			}
		}
	};
</script>
